import { useSearchParams } from "react-router-dom"
import { PageHeader } from "@/components/Molecules/PageHeader/PageHeader"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { FavoritesTab } from "../components/FavoritesTab"
import { NetworkTab } from "../components/NetworkTab"

export default function Network() {
  const [searchParams, setSearchParams] = useSearchParams()

  const activeTab = searchParams.get("activeTab") || "network"

  const handleTabChange = (value: string) => {
    setSearchParams({ activeTab: value })
  }

  return (
    <div className="w-full">
      <PageHeader
        title="Network"
        icon="network-analytic"
      />
      <Tabs
        className="px-6"
        value={activeTab}
        onValueChange={handleTabChange}
      >
        <TabsList className="bg-white/10">
          <TabsTrigger value="network">Network</TabsTrigger>
          <TabsTrigger value="favorites">Favoritos</TabsTrigger>
        </TabsList>
        <TabsContent value="network">
          <NetworkTab />
        </TabsContent>
        <TabsContent value="favorites">
          <FavoritesTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}
